module.exports = __webpack_public_path__ + "img/lloyds-bank.8c0211be.svg";